var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgModelZFeature1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 24C1.5 29.9674 3.87053 35.6903 8.0901 39.9099C12.3097 44.1295 18.0326 46.5 24 46.5C29.9674 46.5 35.6903 44.1295 39.9099 39.9099C44.1295 35.6903 46.5 29.9674 46.5 24C46.5 18.0326 44.1295 12.3097 39.9099 8.0901C35.6903 3.87053 29.9674 1.5 24 1.5C18.0326 1.5 12.3097 3.87053 8.0901 8.0901C3.87053 12.3097 1.5 18.0326 1.5 24V24Z",
    stroke: "#EA80FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 24C16.5 25.9891 17.2902 27.8968 18.6967 29.3033C20.1032 30.7098 22.0109 31.5 24 31.5C25.9891 31.5 27.8968 30.7098 29.3033 29.3033C30.7098 27.8968 31.5 25.9891 31.5 24C31.5 22.0109 30.7098 20.1032 29.3033 18.6967C27.8968 17.2902 25.9891 16.5 24 16.5C22.0109 16.5 20.1032 17.2902 18.6967 18.6967C17.2902 20.1032 16.5 22.0109 16.5 24Z",
    stroke: "#EA80FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9001 30.92L32.6941 44.752",
    stroke: "#EA80FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.08 26.9L3.24805 32.694",
    stroke: "#EA80FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1019 17.082L15.3059 3.24802",
    stroke: "#EA80FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9199 21.1L44.7519 15.306",
    stroke: "#EA80FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1579 30.942L15.4739 44.822",
    stroke: "#EA80FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.058 21.158L3.17798 15.474",
    stroke: "#EA80FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8418 17.058L32.5258 3.17798",
    stroke: "#EA80FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9421 26.842L44.8221 32.526",
    stroke: "#EA80FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgModelZFeature1;